"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Navbar;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _classnames = _interopRequireDefault(require("classnames"));

var _chunk = _interopRequireDefault(require("./navbar/chunk"));

var _logo = _interopRequireDefault(require("./navbar/logo"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Navbar({
  location,
  className,
  startItems,
  endItems,
  children,
  link,
  logoImage,
  logoWidth,
  logoHeight,
  title
}) {
  const [active, setActive] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: (0, _classnames.default)("navbar", className),
    role: "navigation",
    "aria-label": "main navigation",
    itemScope: true,
    itemType: "http://schema.org/SiteNavigationElement"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navbar-brand"
  }, logoImage && /*#__PURE__*/_react.default.createElement(_logo.default, {
    image: logoImage,
    title: title,
    width: logoWidth,
    height: logoHeight,
    link: link
  }), children, (startItems.length > 0 || endItems.length > 0) && /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
    to: link,
    onClick: e => {
      e.preventDefault();
      setActive(!active);
      return false;
    },
    role: "button",
    className: (0, _classnames.default)("navbar-burger", "burger", {
      "is-active": active
    }),
    "aria-label": "menu",
    "aria-expanded": "false"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }), /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }), /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("navbar-menu", {
      "is-active": active
    })
  }, /*#__PURE__*/_react.default.createElement(_chunk.default, {
    className: "navbar-start",
    items: startItems,
    location: location
  }), /*#__PURE__*/_react.default.createElement(_chunk.default, {
    className: "navbar-end",
    items: endItems,
    location: location
  })));
}

Navbar.propTypes = {
  location: _propTypes.default.object,
  className: _propTypes.default.string,
  startItems: _propTypes.default.array.isRequired,
  endItems: _propTypes.default.array.isRequired,
  children: _propTypes.default.any,
  link: _propTypes.default.string.isRequired,
  logoImage: _propTypes.default.string,
  logoWidth: _propTypes.default.number,
  logoHeight: _propTypes.default.number,
  title: _propTypes.default.string
};
Navbar.defaultProps = {
  startItems: [],
  endItems: [],
  link: "/"
};